import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { getExecutionStatusAPI } from "../../../../service/ai-model.service";
import { faCheckCircle, faCirclePause, faCircleXmark, faPause, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { useAIWorkflowContext } from "../../../../context/ai-workflow.context";
import { useAuthContext } from "../../../../context/auth.context";

const Status = {
    Success: 'text-success',
    Failure: 'text-danger',
    NotStared: 'text-draft',
    Pause: 'text-warning'
}
const NodeStatus = ({ id, name, onResult }) => {
    const { workflowExecution, updateWorkflowExecution } = useAIWorkflowContext();
    const { userInfo } = useAuthContext();
    const [nodeStatus, setNodeStatus] = useState({ loading: true, errorNode: [], successNode: [], activeNode: [] });

    useEffect(() => {
        if (workflowExecution && workflowExecution.executionId) {
            getExecutionStatus(workflowExecution.executionId);
        }
    }, [workflowExecution, name])

    const getExecutionStatus = (executionId) => {
        if (name) {
            setNodeStatus({ ...nodeStatus, loading: true })
            getExecutionStatusAPI({ name: `workflow-${userInfo.org.org_name}${name}`, executionId })
                .then((r) => {
                    if (r.successNode.includes(id) || r.errorNode.includes(id)) {
                        setNodeStatus({ loading: false, successNode: r.successNode, errorNode: r.errorNode, activeNode: r.activeNode });
                        if (onResult && r) {
                            onResult(r);
                        }
                    } else {
                        setTimeout(() => getExecutionStatus(executionId), 5 * 1000);
                    }
                }).catch((e) => console.log(e))
        }
    }

    const getConfig = () => {
        let config = {
            icon: faRefresh,
            class: `${Status.NotStared} fa-spin`
        };
        if (nodeStatus && nodeStatus.loading) {
            return config;
        }

        if (nodeStatus && !nodeStatus.loading && nodeStatus.activeNode?.includes(id + '_await_callback')) {
            return {
                icon: faPause,
                class: Status.Pause
            };
        }
        return nodeStatus.errorNode.includes(id) ? {
            icon: faCircleXmark,
            class: Status.Failure
        } : nodeStatus.successNode.includes(id) ? {
            icon: faCheckCircle,
            class: Status.Success
        } : {
            icon: faCirclePause,
            class: Status.NotStared
        };
    }

    const render = () => {
        if (workflowExecution) {
            const config = getConfig();
            return <FontAwesomeIcon
                icon={config.icon}
                size='1x'
                className={config.class} />
        }
    }


    return render()
}

export default NodeStatus